export const pedido_default = {
  id_comissionado: '',
  id_regiao_fiscal: 1,
  id_finalidade: null,
  status_pedido: '',
  data_venda: '',
  id_reserva: '',
  defendeu_dados: false,
  codigo_pagamento_cliente: '',
  status_alocacao: {
    status_alocacao: ''
  },
  seguro: null,
  autoriza_divulgar_dados_cadastrais: null,
  msg_erro: '',
  docusign_falha: null,
  docusign_enviado: null,
  docusign_agendado: null,
  motivo_decisao_credito: '',
  cd_tipo_cota: null,
  qtd_cotas: null,
  qtd_parcela_furo: '',
  cd_simulacao_ed: null,
  opcao_furo: '',
  carrinho: {
    id_carrinho: null,
    qt_cotas: null,
    valor_total_compra: null,
    reserva_com_carrinho: false
  },
  cliente: {
    id_cliente: '',
    id_usuario: '',
    bloqueado: '',
    pessoa: '',
    politicamente_exposto: '',
    genero: '',
    cpf: '',
    cpf_socio: '',
    data_nascimento: '',
    nacionalidade: '',
    naturalidade: '',
    nome_completo: '',
    nome_mae: '',
    id_tipo_documento: '',
    numero_documento: '',
    orgao_expeditor: '',
    data_emissao: '',
    id_estado_civil: '',
    id_profissao: '',
    renda: '',
    telefone_celular: '',
    telefone_residencial: '',
    telefone_comercial: '',
    email: '',
    receber_boletos: '',
    cnpj: '',
    razao_social: '',
    data_fundacao: '',
    id_atividade: '',
    faturamento_medio: '',
    percentual_participacao: '',
    ativo: '',
    completo: '',
    nome_fantasia: '',
    atividade: {},
    saldo_devedor_cliente: '',
    enderecos: [
      {
        id_endereco: '',
        id_cliente: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        id_cidade: '',
        principal: '',
        ativo: '',
        cidade: {
          id_cidade: '',
          nome: '',
          uf: '',
          ddd: '',
          ativo: '',
          descricao: ''
        }
      }
    ]
  },
  beneficiario: {
    nome_completo_beneficiario: '',
    cpf_beneficiario: '',
    beneficiario_politicamente_exposto: ''
  },
  cliente_pedido: {
    cpf: '',
    nome_completo: '',
    politicamente_exposto: '',
    razao_social: '',
    nome_fantasia: '',
    data_fundacao: ''
  },
  produto: {
    id_produto: ''
  },
  bem: {
    id_bem: '',
    nome_bem: '',
    cd_grupo: '',
    valor_bem: ''
  },
  grupo: {
    id_grupo: '',
    cd_grupo: '',
    taxa_adm: '',
    pe_lance_fixo: '',
    pe_seguro: 0,
    dt_vencimento: '',
    dt_assembleia: ''
  },
  plano: {
    id_plano_venda: '',
    id_tipo_venda: '',
    prazo_comercializacao: '',
    tipo_negociacao: '',
    situacao_grupo: '',
    pz_restante: '',
    nome_plano: '',
    valor_parcela: ''
  },
  contrato: {
    id_contrato: '',
    hash_contrato: '',
    status: ''
  },
  analiseCredito: {
    situacao: ''
  },
  historico_envio_boleto: [],
  historico_envio_link: [],
  identificador_representante_tribanco: null,
  aceita_comunicacao_whatsapp: null,
  whatsapp: '',
  multiplicador_cota_habilitado_na_venda: false,
  saldo_para_aumentar: '0'
}
